import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import Switch from "react-switch";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AdminOfflineOffer from "./AdminOfflineOffer";
import OnlineOffer from "./OnlineOffer";

import { makeStyles } from "@material-ui/core";
import AdminAddOnlineOffers from "./AdminAddOnlineOffers";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AdminAddNewOffer = () => {
  const classes = useStyles();
  //state
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add New Offer</div>
              </div>
              {/* <Row className="pb-5">
                <Col lg={8}>
                  <Form.Group>
                    <NewSelectBoxInput
                      selectLabel="Country"
                      name="country"
                      value={state.country}
                      onChange={selecthandleChange}
                      getCountries={getCountries}
                      en={en}
                    />
                  </Form.Group>
                </Col>
                <Col lg={8}>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-State">
                            State
                          </InputLabel>
                          <Select
                            value={state.state}
                            onChange={selecthandleChange}
                            label="State"
                            inputProps={{
                              name: "state",
                              id: "outlined-State",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option value={"State"}>State</option>
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-City">City</InputLabel>
                          <Select
                            value={state.city}
                            onChange={selecthandleChange}
                            label="City"
                            inputProps={{
                              name: "city",
                              id: "outlined-City",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option value={"City"}>City</option>
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col lg={8}>
                  <Form.Group>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-Select Restaurant">
                        Select Restaurant
                      </InputLabel>
                      <Select
                        value={state.restaurant}
                        onChange={selecthandleChange}
                        label="Select Restaurant"
                        inputProps={{
                          name: "restaurant",
                          id: "outlined-restaurant",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={"Restaurant"}>Restaurant</option>
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
              </Row> */}

              <div className="row d-flex align-items-start">
                <div className="col-2">
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion ${
                      selectedTab === 1 ? "active" : ""
                    }`}
                    onClick={(e) => handleTab(1)}
                  >
                    <Image
                      src={
                        selectedTab === 1
                          ? require("../../../../../assets/images/UserManagement/offlineActiveOffer.svg")
                          : require("../../../../../assets/images/UserManagement/offlineDeactiveOffer.svg")
                      }
                      alt="Offline Offers"
                      title="Offline Offers"
                      fluid
                      className="ml-3"
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Offline Offers
                    </span>
                    {selectedTab === 1 ? (
                      <span className="w-100 f9-400 d-block">
                        (Note: these offers can be only be used in your business
                        location offline)
                      </span>
                    ) : null}
                  </Button>
                </div>
                <div className="col-2">
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion ml-3 ${
                      selectedTab === 2 ? "active" : ""
                    }`}
                    onClick={(e) => handleTab(2)}
                  >
                    <Image
                      src={
                        selectedTab === 2
                          ? require("../../../../../assets/images/UserManagement/onlineActiveOffer.svg")
                          : require("../../../../../assets/images/UserManagement/onlineDeactiveOffer.svg")
                      }
                      alt="Online Offers"
                      title="Online Offers"
                      fluid
                      className="ml-3"
                    />
                    <span className="active f12-400 d-block w-100">
                      Online Offers
                    </span>
                  </Button>
                </div>
              </div>
              <div className="py-3 d-flex align-items-center">
                <div className="f16-400 mr-4">User Templates for Design</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">No</div>
                  <Switch
                    onChange={() => {}}
                    // toggleFunction
                    checked={checked.checked}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                    disabled={true}
                  />
                  <div className="f12-400 ml-2">Yes</div>
                </div>
              </div>
              <hr />
              {selectedTab === 1 && <AdminOfflineOffer />}
              {selectedTab === 2 && <AdminAddOnlineOffers />}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AdminAddNewOffer;
